import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faBackspace } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { memo } from 'react';

export type RemoveIconProps = {
    /**
     * Icon to display.
     */
    icon?: IconDefinition;
    /**
     * Color of the icon.
     */
    color?: string;
    /**
     * The `aria-label` to apply.
     */
    ariaLabel?: string;
    /**
     * The title attribute to apply to the icon.
     */
    title?: string;
    /**
     * Classes to apply to the icon element.
     */
    className?: string;
} & Pick<FontAwesomeIconProps, 'size' | 'aria-hidden' | 'aria-label'>;

function RemoveIcon({
    size,
    icon,
    className,
    color,
    title,
    'aria-hidden': ariaHidden,
    'aria-label': ariaLabel,
}: RemoveIconProps) {
    const commonProps = {
        className,
        'aria-hidden': ariaHidden,
    };

    return (
        <FontAwesomeIcon
            {...commonProps}
            icon={icon ?? faBackspace}
            color={color ?? 'var(--error-default)'}
            title={title ?? 'Remove'}
            aria-label={ariaLabel ?? 'Remove'}
            size={size ?? size}
        />
    );
}
const memoRemoveIcon = memo(RemoveIcon);
export { memoRemoveIcon as RemoveIcon };
